
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1078","height":"1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M538.947 822.973L872.016 1024l-88.387-378.88 294.265-254.922-387.503-32.876L538.947 0 387.503 357.322 0 390.198 294.265 645.12 205.878 1024l333.069-201.027z"}})])
          )
        }
      }
    